import React from 'react';
const links = ['Terms of Service', 'Privacy Policy', 'Refund Policy', 'Contact'];
export function Footer() {
  return <footer className="w-full bg-white px-5 py-12" data-id="element-92" data-mp="3ggaq1tbg494e">
      <div className="mx-auto max-w-5xl text-center" data-id="element-93" data-mp="3gh3ng3oilm9v">
        <p className="text-xl font-black uppercase tracking-tight text-stone-900" data-id="element-94" data-mp="32p5lqdx4usnq">
          Hospitality English Ready™
        </p>
        <nav aria-label="Footer" data-id="element-95" data-mp="36nd1p6jrvpxv">
          
        </nav>
        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-stone-400" data-id="element-96" data-mp="3ug3bpa847z5i">
          © 2026 Hospitality English Ready™. All rights reserved.
        </p>
      </div>
    </footer>;
}